var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserDropdownIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75283 1.75H12.2528C12.575 1.75 12.8362 2.01117 12.8362 2.33333V11.6667C12.8362 11.9888 12.575 12.25 12.2528 12.25H1.75283C1.43066 12.25 1.16949 11.9888 1.16949 11.6667V2.33333C1.16949 2.01117 1.43066 1.75 1.75283 1.75ZM11.6695 6.41667H2.33616V11.0833H11.6695V6.41667ZM11.6695 5.25V2.91667H2.33616V5.25H11.6695ZM8.16951 8.75H10.5028V9.91667H8.16951V8.75Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDropdownIcon03);
export default __webpack_public_path__ + "static/media/user-dropdown-icon--03.5704f24e21d603c426c3c3aa7a9a490f.svg";
export { ForwardRef as ReactComponent };